import React, {useState} from "react";

import CRD_PROVIDERS from './crd_providers/crd_providers';
import CRD_STATS from "./crd_stats/crd_stats";



export default function PROVIDERS_LIST() {

    //  variable declarations ------------------------------------------------------------------------------------------

    const [ var_currentStatus, set_currentStatus ] = useState('PUBLISHED')


    //  event listeners ------------------------------------------------------------------------------------------------



    //  async functions ------------------------------------------------------------------------------------------------



    //  API calls ------------------------------------------------------------------------------------------------------



    //  event functions ------------------------------------------------------------------------------------------------



    // RENDER CONTAINER ================================================================================================

    return (
        <div id='page--providers_list' className='page'>
            <div className='page__header'>
                <div className='text--xl medium'>Providers</div>
            </div>

            <CRD_STATS
                set_currentStatus={set_currentStatus}
                var_currentStatus={var_currentStatus}
            />

            <CRD_PROVIDERS
                var_status={'PUBLISHED'}
            />

        </div>
    );

}